import {
  div,
  label,
  ul,
  li,
  span,
  fnlink,
  img,
  button
} from '@srfnstack/fntags'
import { user, refreshCredits } from '../state.js'
import { fnfetch } from '../fetch.js'
import { ALPHA_WHITELIST } from '../utils/alpha.js'

const SidebarItem = ({ to, label, icon }) => li(
  fnlink({
    to,
    class: 'flex items-center gap-3 px-4 py-3 hover:bg-base-300 rounded-lg transition-colors',
    activeClass: 'bg-primary text-primary-content hover:bg-primary/90',
    onclick: () => {
      const drawer = document.getElementById('app-drawer')
      if (drawer) drawer.checked = false
    }
  },
  span({ class: 'material-symbols-rounded' }, icon),
  span(label)
  )
)

export const Sidebar = () => div({ class: 'drawer-side z-50' },
  label({ for: 'app-drawer', class: 'drawer-overlay' }),
  div({ class: 'flex flex-col min-h-full w-64 bg-base-200' },
    div({ style: 'background-color: #282f3f', class: 'p-6 flex flex-col items-center gap-2 border-b border-base-300' },
      img({ src: '/images/etherbuildr_logo.png', alt: 'EtherBuildr', style: 'height: 80px;' })
    ),
    ul({ class: 'menu p-4 text-base-content gap-2 flex-grow' },
      SidebarItem({ to: '/', label: 'Generate Artwork', icon: 'auto_awesome' }),
      SidebarItem({ to: '/artwork-review', label: 'Artwork Manager', icon: 'photo_library' }),
      SidebarItem({ to: '/product-review', label: 'Product Concepts', icon: 'category' }),
      SidebarItem({ to: '/mockup-audit', label: 'Mockup Audit', icon: 'straighten' }),
      SidebarItem({ to: '/pin-queue', label: 'Pin Queue', icon: 'push_pin' }),
      SidebarItem({ to: '/pinterest-stats', label: 'Pinterest Stats', icon: 'insights' }),
      SidebarItem({ to: '/artwork-approval', label: 'Artwork Approval', icon: 'image' }),
      SidebarItem({ to: '/approval-queue', label: 'Approval Queue', icon: 'task_alt' }),
      SidebarItem({ to: '/autopilot-decisions', label: 'Autopilot Decisions', icon: 'reviews' }),
      SidebarItem({ to: '/gate-labeling', label: 'Gate Labelling', icon: 'rule' }),
      SidebarItem({ to: '/autopilot-pipeline', label: 'Autopilot Pipeline', icon: 'account_tree' }),
      SidebarItem({ to: '/tags', label: 'Tag Library', icon: 'sell' }),
      user.bindAs(u => (u.tenant_id === 1 && u.role === 'SUPER_ADMIN')
        ? SidebarItem({ to: '/bulk-operations', label: 'Bulk Operations', icon: 'sync' })
        : ''
      ),
      user.bindAs(u => (u.tenant_id === 1 && u.role === 'SUPER_ADMIN')
        ? SidebarItem({ to: '/queue', label: 'Queue Manager', icon: 'rebase_edit' })
        : ''
      ),
      div({ class: 'divider my-2' }),
      SidebarItem({ to: '/finance', label: 'Finance Hub', icon: 'payments' }),
      SidebarItem({ to: '/orders', label: 'Order Tracking', icon: 'local_shipping' }),
      user.bindAs(u => (u.tenant_id === 1 && u.role === 'SUPER_ADMIN')
        ? SidebarItem({ to: '/tenants', label: 'Tenants', icon: 'corporate_fare' })
        : ''
      ),
      user.bindAs(u => (u.tenant_id === 1 && u.role === 'SUPER_ADMIN')
        ? SidebarItem({ to: '/governance', label: 'Governance', icon: 'shield' })
        : ''
      ),
      SidebarItem({ to: '/settings', label: 'Settings', icon: 'settings' }),
      SidebarItem({ to: '/help', label: 'Help & Docs', icon: 'help' }),
      SidebarItem({ to: '/graveyard', label: 'Graveyard', icon: 'delete_forever' }),
      div({ class: 'divider my-2' }),
      user.bindAs(u => ALPHA_WHITELIST.includes(u.email)
        ? li(
          button({
            class: 'flex items-center gap-3 px-4 py-3 hover:bg-accent hover:text-accent-content rounded-lg transition-colors w-full text-left',
            onclick: async () => {
              const res = await fnfetch('/api/system/alpha-credits', { method: 'POST' })
              if (res.ok) await refreshCredits()
            }
          },
          span({ class: 'material-symbols-rounded' }, 'token'),
          span('Give Me More Credits')
          )
        )
        : ''
      ),
      li(
        button({
          class: 'flex items-center gap-3 px-4 py-3 hover:bg-error hover:text-error-content rounded-lg transition-colors w-full text-left',
          onclick: async () => {
            const drawer = document.getElementById('app-drawer')
            if (drawer) drawer.checked = false
            await fnfetch('/api/auth/logout', { method: 'POST' })
            user({ loggedIn: false })
            window.location.href = '/login'
          }
        },
        span({ class: 'material-symbols-rounded' }, 'logout'),
        span('Logout')
        )
      )
    )
  )
)
